// extracted by mini-css-extract-plugin
export default {"first":"#0a4d28","productTextBody":"Kora_ozdobna_productTextBody__8YEV9","green":"Kora_ozdobna_green__f8MgX"};